// extracted by mini-css-extract-plugin
module.exports = {"notfound_wrapper":"errorPage_notfound_wrapper__046fj","notfound":"errorPage_notfound__OUJ50","notfound_404":"errorPage_notfound_404__6l0LN"};